<footer [class.has-bubbles]="!store.currentQuestion()">
  @if (store.hasStarted()) {
    @if (store.currentQuestion(); as question) {
      <div class="footer-box">
        @if (question.isCorrect === undefined) {
          <img class="footer-image" [attr.src]="question.image" />
          <h2 class="pr-u-h3 pr-u-textLeft pr-u-marginBlockEnd150">{{ question.text }}</h2>
          <div class="footer-choices">
            @for (choice of question.choices; track choice) {
              <button
                type="button"
                luButton="outlined"
                palette="neutral"
                class="footer-choice"
                (click)="store.resolveChoice(question, choice)"
              >
                {{ choice | capitalize }}
              </button>
            }
          </div>
        } @else {
          <img class="footer-image" [attr.src]="question.image" />
          <div class="footer-answer">
            @if (question.isCorrect) {
              <h2 class="pr-u-h3 pr-u-displayFlex pr-u-alignItemsCenter pr-u-gap100">
                <lu-icon icon="signSuccess" color="success" />
                <span>Bonne réponse !</span>
              </h2>
            } @else {
              <h2 class="pr-u-h3 pr-u-displayFlex pr-u-alignItemsCenter pr-u-gap100">
                <lu-icon icon="signError" color="error" />
                <span>Mauvaise réponse...</span>
              </h2>
            }
            <p class="box mod-comment">{{ question.comment }}</p>
          </div>
          <button type="button" luButton (click)="store.clearCurrentQuestion()">Continuer à jouer</button>
          <!-- OU button type="button" luButton>Terminer</button-->
        }
      </div>
    }
  }
</footer>
